module.exports = __webpack_public_path__ + "static/media/img_banner.9762506f.png";